export default {
  api: {
    baseUrl: 'https://api-admindev.makna.ai',
    chatUrl: 'https://api-admindev.makna.ai/api',
    backOfficeUrl: 'https://api-admindev.makna.ai/api',
    leadsUrl: 'https://dev.api.x.makna.ai/leads',
  },
};
